import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss']
})
export class ModalContentComponent {

  @Input() confirmationBoxTitle;
  @Input() confirmationMessage;
  @Input() bevestig: boolean = true;
  constructor(public activeModal: NgbActiveModal, 
   ) {}
  
}
